module.exports = __webpack_public_path__ + "static/04-7780c697573f9760f7e38de40df1a958.png";